module.exports = __webpack_public_path__ + "static/portfolio-image-2-cda88cca9f051f05990d86b7f38fd40c.jpg";